import clsx from 'clsx';
import { Link as RouterLink, LinkProps } from 'react-router-dom';

export const Link = ({ className, children, ...props }: LinkProps) => {
  return (
    <RouterLink
      className={clsx('text-royal-blue-600 hover:text-royal-blue-900', className)}
      {...props}
    >
      {children}
    </RouterLink>
  );
};
